import $ from "jquery";

$(function () {
  $(".res-form-btn").on("click", function (e) {
    e.preventDefault();

    const uid = $(this).attr("data-uid");
    const resInlineForm = $("#resInlineForm-" + uid);
    const datePickerElement = $("#datepicker-" + uid);
    const resInlineFormDisplay = $(resInlineForm).css("display");
    datePickerElement.datepicker({
      minDate: "0d",
      maxDate: "+14d",
      altField: "#move_in_date_hidden_" + uid,
      ...(typeof datepickerConfig !== "undefined" ? datepickerConfig : {})
    });

    if (resInlineFormDisplay === "none") {
      resInlineForm.slideDown();
      $(".res-form-btn").each(function () {
        const otherUid = $(this).attr("data-uid");
        const otherResInlineForm = $("#resInlineForm-" + otherUid);
        const otherResInlineFormDisplay = $(otherResInlineForm).css("display");
        if (otherResInlineFormDisplay !== "none" && otherUid !== uid) {
          otherResInlineForm.slideUp();
          $(this).html("Reserve");
        }
      });
      $(this).html("<span>Close</span>");
    } else {
      resInlineForm.slideUp();
      $(this).html("Reserve");
    }
  });

  $(".res-dropdown-form").on("submit", function () {
    $(this)
      .find('button[type="submit"], input[type="submit"]')
      .attr("disabled", true);
    $(this).find(".se-spinner").show();
  });
});
